import { create } from "zustand";
import { persist } from "zustand/middleware";

interface Note {
  id: string;
  content: string;
}

interface NotesStore {
  notes: Note[];
  addNote: (content: string) => void;
  updateNote: (id: string, content: string) => void;
  deleteNote: (id: string) => void;
}

const useNotesStore = create<NotesStore>()(
  persist(
    (set) => ({
      notes: [],
      addNote: (content) =>
        set((state) => {
          const newNote: Note = { id: Date.now().toString(), content };
          return { notes: [...state.notes, newNote] };
        }),
      updateNote: (id, content) =>
        set((state) => ({
          notes: state.notes.map((note) =>
            note.id === id ? { ...note, content } : note
          ),
        })),
      deleteNote: (id) =>
        set((state) => ({
          notes: state.notes.filter((note) => note.id !== id),
        })),
    }),
    {
      name: "notes",
    }
  )
);

export default useNotesStore;
